import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const SlideDetail = () => {
  return (
    <Stack>
      <Box
        width='470px'
        height='564px'
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        sx={{ backgroundColor: '#AAB2BD' }}
      >
        <Typography fontSize={'20px'} fontWeight={400} color={'primary.light'}>
          患者詳細
        </Typography>
      </Box>
      <Typography
        fontSize={'10px'}
        fontWeight={400}
        color={'#AAB2BD'}
        textAlign={'right'}
        mt={'6px'}
      >
        1-10/100
      </Typography>
    </Stack>
  );
};

export default SlideDetail;
